import React from "react";
import MaterialStituationInfo from "./MaterialStituationInfo";

interface IcomeSourceProps {
  incomeSources: any;
  form: any;
  orphanCount: number;
}

const IncomeSourceData = ({
  incomeSources,
  form,
  orphanCount,
}: IcomeSourceProps) => {
  return (
    <div className="takaful--recipient-container">
      <MaterialStituationInfo
        orphanCount={orphanCount}
        form={form}
        incomeSources={incomeSources}
      />
    </div>
  );
};

export default IncomeSourceData;
